/**
 * Constants used throughout the flare context module
 */

import { UseCaseName } from "@amzn/fuse-accounting-central-datastore-client";

// Time constants
export const CLIENT_CLEANUP_TIMEOUT_MS = 30 * 60 * 1000; // 30 minutes

// Batch size for GetFlareConfig requests to avoid 413 response size errors
// Lambda has a 10MB response size limit, so we split paths into smaller batches
export const FLARE_CONFIG_PATH_BATCH_SIZE = 10;

// GL Line Description Suffixes
export const GlLineDescriptionSuffixHelper = {
  isSale: (suffix?: string) => suffix === "Sale" || suffix === "Venda_Liquida",
  isAmortization: (suffix?: string) =>
    suffix === "Amortization" || suffix === "Amortizacao",
  isCancelation: (suffix?: string) =>
    suffix === "Cancelation" || suffix === "Cancelamento",
  isCancelationTrueUp: (suffix?: string) =>
    suffix === "Cancelation_True_Up" || suffix === "Cancelamento_Ajuste",
};

// API constants
export const CBOR_CONTENT_TYPE = "application/cbor";
export const AWS_REGION = "us-west-2";

// Error messages
export const ERROR_MESSAGES = {
  CONTEXT_NOT_FOUND: "useFlareContext must be used within FlareContextProvider",
  MALFORMED_RESPONSE: "Malformed response: ragaAvailabilities not found",
  PARSING_ERROR: "Error parsing flare config:",
} as const;

// Account number constants
export const ACCOUNT_NUMBERS = {
  RECEIVABLE: ["13161", "23200"] as readonly string[],
  DEFERRED_SUBSCRIPTION_REVENUE: ["23150"] as readonly string[],
};

// Common field names used in USL lines
export const SEVEN_SEGMENTS_USL_LINE_FIELDS = {
  COMPANY_CODE: "companyCode",
  LOCATION: "location",
  COST_CENTER: "costCenter",
  ACCOUNT_NUMBER: "accountNumber",
  PRODUCT_LINE: "productLine",
  CHANNEL: "channel",
  PROJECT: "project",
} as const;

export const USL_LINE_FIELD_NAMES = Object.values(
  SEVEN_SEGMENTS_USL_LINE_FIELDS,
);

// Discrepancy status types
export type DiscrepancyStatus = "match" | "mismatch" | "missing";

export const FLARE_COMPARISON_USE_CASES = [
  UseCaseName.SALE,
  UseCaseName.AMORTIZATION,
  UseCaseName.HARD_CANCEL_WITHOUT_REFUND,
  UseCaseName.HARD_CANCEL_WITH_REFUND,
] as UseCaseName[];

// Type guards for account numbers
export function isReceivableAccount(
  accountNumber: string | undefined,
): boolean {
  return !!accountNumber && ACCOUNT_NUMBERS.RECEIVABLE.includes(accountNumber);
}

export function isDeferredRevenueAccount(
  accountNumber: string | undefined,
): boolean {
  return (
    !!accountNumber &&
    ACCOUNT_NUMBERS.DEFERRED_SUBSCRIPTION_REVENUE.includes(accountNumber)
  );
}
